import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { BUSINESS } from "../data/site";
import { LogOut } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Fichas" },
  { to: "/admin/calendario", label: "Calendário" },
];

export function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-[#F4F4F0] font-body text-[#0A0A0A]">
      <header className="sticky top-0 z-40 bg-[#0A0A0A] text-white">
        <div className="max-w-[1200px] mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <button onClick={() => navigate("/admin")} className="flex items-center gap-3" data-testid="admin-home">
              <img src={BUSINESS.logo} alt="Patolas" className="h-9 w-auto object-contain bg-white rounded-md p-0.5" />
            </button>
            <nav className="flex items-center gap-1">
              {NAV.map((n) => {
                const active = n.to === "/admin" ? location.pathname === "/admin" : location.pathname.startsWith(n.to);
                return (
                  <Link
                    key={n.to}
                    to={n.to}
                    data-testid={`admin-nav-${n.label.toLowerCase()}`}
                    className={`text-sm px-3.5 py-1.5 rounded-full transition-colors ${
                      active ? "bg-[#E20074] text-white" : "text-[#a3a3a3] hover:text-white"
                    }`}
                  >
                    {n.label}
                  </Link>
                );
              })}
            </nav>
          </div>
          <div className="flex items-center gap-4">
            <div className="text-right hidden sm:block">
              <p className="text-sm font-medium leading-tight">{user?.name}</p>
              <p className="text-xs text-[#a3a3a3] capitalize">{user?.role === "admin" ? "Administrador" : user?.role}</p>
            </div>
            <button
              onClick={logout}
              data-testid="logout-btn"
              className="flex items-center gap-2 text-sm bg-[#1e1e1e] hover:bg-[#E20074] transition-colors px-3.5 py-2 rounded-full"
            >
              <LogOut size={15} />
              <span className="hidden sm:inline">Sair</span>
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-[1200px] mx-auto px-5 md:px-8 py-8">{children}</main>
    </div>
  );
}
